export interface RouteStatus {
  name: string;
  value: ROUTE_STATUS;
}
export enum ROUTE_STATUS {
  STARTED = 'STARTED',
  PENDING = 'PENDING',
  FINISHED = 'FINISHED',
  FINISHED_WITH_ERRORS = 'FINISHED_WITH_ERRORS'
}
